import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AccessControlDomainModule } from '@p2p/access-control/domain';

import { PermissionsApiService } from './services/permissions-api.service';

@NgModule({
    imports: [CommonModule, AccessControlDomainModule],
    providers: [PermissionsApiService]
})
export class AccessControlApiModule {}
